export default "__VITE_ASSET__Dv9qew_p__"